import { BsSearch } from 'react-icons/bs';
import styled from 'styled-components';
import selectArrow from '../../static/images/landingPage/arrow_dropdown.png';
import selectDivider from '../../static/images/landingPage/divider.png';
import { deviceMax } from '../../styles/MediaQuery';
import {
    black,
    blue,
    containerWidth,
    darkGreen,
    greenBackground,
    greenPrintDarker,
    greyBorder,
    greyLight,
    lightGray,
    white,
} from '../../styles/Variables';

export const Container = styled.div`
    display: flex;
    justify-content: center;
`;

export const ContentWrapper = styled.div`
    width: ${containerWidth};
    box-sizing: border-box;

    @media (max-width: 970px) {
        width: calc(100% - 30px);
    }
`;

export const HeaderText = styled.h1`
    color: ${blue};
    font-size: 2.5em;
    font-weight: 700;
    font-family: 'NeueHelveticaPro77CondensedBold', Helvetica, Arial;
    letter-spacing: 0.025em;
    line-height: 44px;
    margin-bottom: 1rem;
    margin-top: 1.5em;
    word-break: break-word;
    overflow-wrap: break-word;
`;

export const SearchWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-end;
    padding: 1em 1.3em;
    background-color: ${greenBackground};
    box-sizing: border-box;
    @media ${deviceMax.tablet} {
        justify-content: center;
        align-items: center;
        padding: 1em 0;
    }
`;

export const SearchFrom = styled.form`
    display: flex;
    flex-direction: column;
    position: relative;
    @media ${deviceMax.tablet} {
        margin-bottom: 1em;
    }
`;

interface ProductBoxProps {
    readonly isActive: boolean;
}

export const Select = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: url(${selectDivider}) no-repeat 84% 43%, url(${selectArrow}) no-repeat 93% 45%,
        linear-gradient(180deg, #fafbfc 30%, #eff2f5 90%);
    border: 1px solid ${lightGray};
    cursor: pointer;
    padding-left: 0.8rem;
    font-size: 15px;
    width: 270px;
    height: 2.5rem;
    color: ${darkGreen};
    border-radius: 5px;
    appearance: none;
    outline: none;
    margin: 0;
    transition: 0.3s;
    &:hover {
        color: ${greenPrintDarker};
    }
`;

export const ProductBox = styled.div<ProductBoxProps>`
    ${(props) =>
        props.isActive
            ? {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
              }
            : {
                  display: 'none',
              }}
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border: 1px solid ${lightGray};
    border-radius: 3px;
    position: absolute;
    top: 100%;
    z-index: 10;
    cursor: pointer;
`;

export const ProductList = styled.ul`
    cursor: pointer;
    width: 100%;
    margin: 0;
    padding: 0;
`;

export const ProductListOption = styled.li`
    font-size: 0.875rem;
    color: ${darkGreen};
    background-color: white;
    line-height: 3em;
    font-weight: 200;
    padding: 5px 0 5px 1.25rem;
    border-bottom: 1px solid ${lightGray};
    transition: 0.3s;
    &:hover {
        color: ${greenPrintDarker};
        background-color: ${greyLight};
    }
`;

export const InputSearchWithIconWrapper = styled.div`
    @media ${deviceMax.tablet} {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 1em;
        border-top: 1px solid white;
    }
`;

interface ResultWrapperInterface {
    isFixed: boolean;
}

export const ResultsWrapper = styled.div<ResultWrapperInterface>`
    @media ${deviceMax.tablet} {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-top: ${({ isFixed }) => (isFixed ? '1em' : '0.5em')};
        padding-bottom: ${({ isFixed }) => (isFixed ? '0' : '0.5em')};
        border-top: ${({ isFixed }) => (isFixed ? '1px solid white' : 'none')};
        border-left: ${({ isFixed }) => (isFixed ? 'none' : '2px solid white')};
    }

    * {
        color: ${white};
    }
`;

export const ResultsNumber = styled.span`
    font-size: 2.375rem;
    font-weight: 400;
    line-height: 1.55rem;

    @media ${deviceMax.tablet} {
        line-height: 1.15;
    }
`;

export const ResultsTitle = styled.h2`
    font-size: 0.9375rem;
    text-transform: uppercase;
    font-weight: 200;
    margin: 0;
    padding: 0;
`;

export const InputSearchWithIcon = styled.form`
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
`;

export const InputSearch = styled.input`
    box-sizing: border-box;
    border: 1px solid ${lightGray};
    outline: none;
    padding-left: 0.8rem;
    padding-right: 2.5em;
    padding-top: 0.3em;
    border-radius: 5px;
    width: 285px;
    height: 2.5rem;
    line-height: 25px;
`;

export const SearchIcon = styled(BsSearch)`
    fill: ${darkGreen};
    position: absolute;
    right: 10px;
    cursor: pointer;
`;

export const SelectDivider = styled.div`
    height: 70%;
    width: 1px;
    background: url(${selectDivider});
    position: absolute;
    right: 2.1em;
`;

export const CardWrapper = styled.div`
    margin-top: 2.5em;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1.25em;
    width: 100%;
    padding-bottom: 5em;
    border-bottom: 1px solid ${greyBorder};
    @media ${deviceMax.laptop} {
        grid-template-columns: 1fr 1fr;
    }
    @media ${deviceMax.tablet} {
        grid-template-columns: 1fr;
    }
`;

export const Card = styled.div`
    background-color: ${greyLight};
    padding: 1.25em;
    display: flex;
    flex-direction: column;
    cursor: pointer;
`;

export const CardHeader = styled.h2`
    color: ${black};
    letter-spacing: 0.025em;
    text-transform: uppercase;
    line-height: 20px;
    font-weight: 700;
    font-size: 0.9em;
`;

export const CardImageWrapper = styled.div`
    align-self: center;
    height: 100%;
    display: flex;
    align-items: center;
    margin-top: 1.2em;
    margin-bottom: 0.5em;
`;

export const MobileResultWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: ${greenBackground};
    box-sizing: border-box;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 5;
`;

export const ResetButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    color: ${white};
    font-weight: 700;
    font-size: 1rem;
    text-transform: capitalize;
    padding: 0 20px;
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;

    &:focus {
        border: none;
    }

    * {
        line-height: 1rem;
    }
`;
